export const deal_type = {
    "player_deal" : 1,
    "team_deal" : 2,
    "players_deal" : 3,
    "teams_deal" : 4
}